export enum DbOrderDirection {
  ASC = 'asc',
  DESC = 'desc',
}
